jQuery(document).ready(function($) {
    // Get CookieBox
    var cookieBox = document.getElementById('cookiebarBox');
     $(".cookieBoxok").on('click', function(event){
        event.stopPropagation();
        event.stopImmediatePropagation();
        cookieBox.style.display = "none";
    });
 });
   
 (function () {
 
     /**
      * Set cookie
      */
     function createCookie(name, value, days, path) {
         var expires = "";
         if (days) {
             var date = new Date();
             date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
             expires = "; expires=" + date.toGMTString();
         }
         else expires = "";
         document.cookie = name + "=" + value + expires + "; path=" + path;
     }
 
     function readCookie(name) {
         var nameEQ = name + "=";
         var ca = document.cookie.split(';');
         for (var i = 0; i < ca.length; i++) {
             var c = ca[i];
             while (c.charAt(0) == ' ') c = c.substring(1, c.length);
             if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
         }
         return null;
     }
 
     // Set/update cookie
     var cookieExpiry = 30;
     var cookiePath = "/";
 
     $(".cookieBoxok").on('click', function(event){
        createCookie('seen-cookiePopup', 'yes', cookieExpiry, cookiePath);
    });
 
     var cookiePopup = readCookie('seen-cookiePopup');
     if (cookiePopup != null && cookiePopup == 'yes') {
         cookiebarBox.style.display = 'none';
     } else {
         cookiebarBox.style.display = 'block';
     }
 })();

function popularSearchCarousel(target = document) {
  $(target).find('.js-popular-searches').slick({
    dots: false,
    arrows: true,
    infinite: true,
    speed: 300,
    variableWidth: true,
    slidesToShow: 7,
    slidesToScroll: 1,
    prevArrow: false,
    nextArrow: '<div class="popular-searches__nav popular-searches__nav--next"><svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="m8.625 5.25 6.75 6.75-6.75 6.75" stroke="#000" stroke-linecap="round" stroke-linejoin="round"/></svg></div>'
  });
}

function initImageAndTextCarousel(target = document) {
  $(target).find(".js-slider").slick({
    arrows: true,
    slidesToScroll: 3,
    slidesToShow: 4,
    speed: 300,
    easing:'linear',
    infinite: false,
    prevArrow: '<div class="image-text-carousel__nav image-text-carousel__nav--prev"><svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M15.375 5.25 8.625 12l6.75 6.75" stroke="#000" stroke-linecap="round" stroke-linejoin="round"/></svg></div>',
    nextArrow: '<div class="image-text-carousel__nav image-text-carousel__nav--next"><svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="m8.625 5.25 6.75 6.75-6.75 6.75" stroke="#000" stroke-linecap="round" stroke-linejoin="round"/></svg></div>',
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2.3,
        }
      }
    ],
  });
}

function homeBlogCarousel(target = document) {
  $(target).find('.js-home-blog').slick({
    dots: false,
    arrows: false,
    infinite: false,
    speed: 300,
    slidesToScroll: 1,
    slidesToShow: 3,
    responsive: [
      {
        breakpoint: 675,
        settings: {
          slidesToShow: 1.2
        }
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2
        }
      }
    ]
  })
}

function initBrandCarousel(target = document) {
  $(target).find('.brand-carousel-responsive').slick({
    dots: false,
    arrows: true,
    infinite: true,
    speed: 300,
    slidesToShow: 3,
    slidesToScroll: 1,
    prevArrow: '<div class="home-carousel__nav home-carousel__nav--prev"><i class="icon icon--left-t"></i></div>',
    nextArrow: '<div class="home-carousel__nav home-carousel__nav--next"><i class="icon icon--right-t"></i></div>',
    responsive: [
      {
        breakpoint: breakpoints.phab,
        settings: {
          slidesToShow: 2
        }
      }
    ]
  })
}

function initProductCarousel(target = document) {
  $(target).find(".js-product-carousel").slick({
    arrows: true,
    infinite: false,
    dots: true,
    speed: 300,
    slidesToScroll: 2,
    slidesToShow: 5,
    prevArrow: '<div class="image-text-carousel__nav image-text-carousel__nav--prev"><svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M15.375 5.25 8.625 12l6.75 6.75" stroke="#000" stroke-linecap="round" stroke-linejoin="round"/></svg></div>',
    nextArrow: '<div class="image-text-carousel__nav image-text-carousel__nav--next"><svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="m8.625 5.25 6.75 6.75-6.75 6.75" stroke="#000" stroke-linecap="round" stroke-linejoin="round"/></svg></div>',
    responsive: [
      { 
        breakpoint: 850,
        settings: {
          slidesToShow: 4
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2
        }
      }
    ]
  });
}

$(document).ready(function(){
  popularSearchCarousel()
  initImageAndTextCarousel()
  homeBlogCarousel()
  initBrandCarousel()
  initProductCarousel()
});

if (Shopify.designMode) {
  $(document).on('shopify:section:load', function (section) {
    const targetEl = section.target
    if ($(targetEl).hasClass('product-carousel')) {
      initProductCarousel(targetEl)
    } else if ($(targetEl).hasClass('image-text-carousel')) {
      initImageAndTextCarousel(targetEl)
    } else if ($(targetEl).hasClass('brand-carousel')) {
      initBrandCarousel(targetEl)
    } else if ($(targetEl).hasClass('popular-search')) {
      popularSearchCarousel(targetEl)
    } else if ($(targetEl).hasClass('home-blog')) {
      homeBlogCarousel(targetEl)
    }
  })
}
